import useForceUpdate from './useForceUpdate';
import {useMemo} from 'react';
import abstractGetSyncPromise, {GetSyncPromise} from '../abstractGetSyncPromise';
import {debounce} from 'lodash';

export {SyncPromise, GetSyncPromise} from '../abstractGetSyncPromise';

export default function useGetSyncPromise<T>(): GetSyncPromise {
    const forceUpdate = useForceUpdate();
    return useMemo(() => {
        const debouncedForceUpdate = debounce(forceUpdate);
        return abstractGetSyncPromise({
            onPromiseReject: debouncedForceUpdate,
            onPromiseResolve: debouncedForceUpdate,
        });
    }, [forceUpdate]);
}
